// leasing-preapproval-form.js (Final Corrected Version with All Fixes)
(function () {
  // =========================
  // Config
  // =========================
  const VALIDATION_ENABLED = true; // hard-gate steps + submit
  const CUR_YEAR = new Date().getFullYear();
  // Business rule, not inferred: confirmed max Lease Amount Required.
  const MAX_LEASE_AMOUNT = 5000000;

  // ===== HubSpot Forms API (Option B: parallel data sink, no UX change) =====
  // Separate HubSpot form from the full Credit Application -- fixes the
  // pre-existing issue (noted in docs/fixes/fix-pass-hubspot-form-audit.md)
  // of both leasing forms sharing one form id and merging in HubSpot.
  //
  // Routed through the same-origin form relay (Shopify App Proxy ->
  // nella-app-proxy -> Linen Plus Middleware -> HubSpot), not a direct
  // client-side call to api.hsforms.com -- confirmed blocked by ad
  // blockers/tracking protection on a real visitor's browser. See
  // docs/testing/form-relay-strategy.html. The portal/form GUID now
  // live server-side in Linen Plus Middleware's HUBSPOT_FORM_GUIDS.
  const RELAY_URL = '/apps/nella-app-login/forms/leasing_pre_approval';
  const FORM_TOKEN_URL = '/apps/nella-app-login/forms-token';
  // This form only ever has one shareholder (no add-row here), but the slot
  // cap is kept for symmetry with the full form's mapping logic.
  const HUBSPOT_SHAREHOLDER_SLOTS = 3;

  // =========================
  // Progress ring
  // =========================
  const meter = document.querySelector('.progress-ring__meter');
  const txt = document.querySelector('.progress-circle__percentage');
  const CIRC = 408.4;
  function setProgress(pct) {
    if (!meter) return;
    const clamped = Math.max(0, Math.min(100, pct));
    meter.style.strokeDasharray = CIRC;
    meter.style.strokeDashoffset = CIRC - (CIRC * clamped / 100);
    if (txt) {
      txt.innerHTML =
        '<span class="progress-circle__value">' +
        Math.round(clamped) +
        '</span><span class="progress-circle__unit">%</span>';
    }
  }
  // =========================
  // Capture SKU/Product from URL
  // =========================
  function getUrlParams() {
    const p = new URLSearchParams(window.location.search);
    return {
      sku: (p.get('sku') || '').trim(),
      product: (p.get('product') || '').trim(),
      variant: (p.get('variant') || '').trim(),
    };
  }

  // Still used by prefillFromReferral() (in wireProductSearch(), further
  // down) to auto-add the referred product to Equipment Required -- the
  // separate Product Referral email section/HubSpot fields that used to
  // read this too were removed as duplicate coverage of the same data.
  const urlCtx = getUrlParams();

  function wireUpDatepicker(element) {
    // Ensure jQuery and the datepicker plugin are available
    if (!element || typeof $ === 'undefined' || !$.fn.datepicker) {
      return;
    }

    const $el = $(element);

    // Clean slate
    $el.datepicker('destroy');

    // Attach the double-click listener
    $el.on('dblclick', function () {
      const currentValue = $(this).val();
      let newStartView = 'decades'; // Default: start with years
      let defaultDate = new Date(); // Default to today

      // Logic: Determine where to jump based on what is typed
      const yearMatch = currentValue.match(/^(\d{4})/);
      const monthMatch = currentValue.match(/^\d{4}-(\d{2})/);

      if (monthMatch) {
        // If "2012-05" is typed -> Jump to Days view of May 2012
        newStartView = 'days';
        defaultDate = new Date(parseInt(yearMatch[1]), parseInt(monthMatch[1]) - 1, 1);
      } else if (yearMatch) {
        // If "2012" is typed -> Jump to Months view of 2012
        newStartView = 'months';
        defaultDate = new Date(parseInt(yearMatch[1]), 0, 1); // Jan 1st of that year
      }

      // Prevent jumping to future dates
      if (defaultDate > new Date()) {
        defaultDate = new Date();
      }

      // === THE TRICK ===
      // 1. Temporarily remove the value so the library listens to 'defaultViewDate'
      // instead of trying to parse the incomplete text "2012" and failing.
      $(this).val('');

      // 2. Initialize with our custom settings
      $(this).datepicker('destroy').datepicker({
        format: "yyyy-mm-dd",
        autoclose: true,
        todayHighlight: true,
        startView: newStartView,
        defaultViewDate: defaultDate, // This forces the year/month view
        endDate: "0d",
        forceParse: false // Important: Don't auto-format the text when we put it back
      });

      // 3. Put the user's text back immediately
      $(this).val(currentValue);

      // 4. Show the calendar
      $(this).datepicker('show');

      // Remove default focus behavior so single click doesn't reopen it
      $(this).off('focus');
    });
  }
  function isValidDate(dateString) {
    // 1. Regex check for YYYY-MM-DD format
    if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) return false;

    // 2. Parse parts to check calendar logic
    const parts = dateString.split('-');
    const year = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10);
    const day = parseInt(parts[2], 10);

    // 3. Basic range check (Year 1900-2100, Month 1-12)
    if (year < 1900 || year > 2100 || month === 0 || month > 12) return false;

    // 4. Strict Day Check using JS Date object
    // (JavaScript automatically rolls over dates, e.g. Feb 30 -> Mar 2)
    // We check if the Input matches the Output to detect invalid days.
    const testDate = new Date(year, month - 1, day);
    return (
      testDate.getFullYear() === year &&
      testDate.getMonth() === month - 1 &&
      testDate.getDate() === day
    );
  }
  function wireUpDateMask(element) {
    if (!element) return;

    element.addEventListener('input', (e) => {
      // 1. Allow only numbers and dashes
      let value = e.target.value.replace(/[^0-9]/g, '');

      // 2. Auto-insert dashes
      if (value.length > 4) {
        value = value.slice(0, 4) + '-' + value.slice(4);
      }
      if (value.length > 7) {
        value = value.slice(0, 7) + '-' + value.slice(7, 9);
      }

      // 3. Hard limit length to 10 chars (YYYY-MM-DD)
      if (value.length > 10) {
        value = value.slice(0, 10);
      }

      e.target.value = value;
    });

    element.addEventListener('blur', (e) => {
      const value = e.target.value;

      if (!value.length) {
        // Empty: clear any existing error for this field
        clearErrorFor(e.target);
        return;
      }

      if (!isValidDate(value)) {
        showError(e.target, 'Invalid Date (YYYY-MM-DD)');
      } else {
        // Value is now valid – remove the tooltip immediately
        clearErrorFor(e.target);
      }
    });
  }

  // =========================
  // DOM refs
  // =========================
  const formEl = document.getElementById('LeasingForm');
  const stepsNav = document.getElementById('form-steps');

  const step1 = document.getElementById('step-1');
  const step2 = document.getElementById('step-2');
  const step3 = document.getElementById('step-3');

  const goToStep2 = document.getElementById('go-to-step-2');
  const backToStep1 = document.getElementById('back-to-step-1');
  const goToStep3 = document.getElementById('go-to-step-3');
  const backToStep2 = document.getElementById('back-to-step-2');
  const submitBtn = document.getElementById('submit-form');

  // Radios default unselected (pre-approval wants clean start)
  document.querySelectorAll('input[type="radio"]').forEach(r => { r.checked = false; });

  // =========================
  // Utility: sticky offsets & scrolling
  // =========================
  function measureStickyStack() {
    const candidates = [
      document.getElementById('shopify-section-header'),
      document.querySelector('.shopify-section-header'),
      document.querySelector('.announcement-bar-holder'),
      document.querySelector('header'),
    ];
    let maxBottom = 0;
    for (const el of candidates) {
      if (!el) continue;
      const r = el.getBoundingClientRect();
      if (r.top <= 2) maxBottom = Math.max(maxBottom, r.bottom);
    }
    return Math.ceil(maxBottom + 12);
  }
  function syncScrollPaddingTop() {
    const off = measureStickyStack();
    document.documentElement.style.setProperty('--sticky-offset', off + 'px');
  }
  function setTitleScrollMargin(sectionEl) {
    const title = sectionEl?.querySelector('.form-content__title');
    if (!title) return;
    title.style.scrollMarginTop = measureStickyStack() + 'px';
  }
  function getScrollContainer(el) {
    let node = el?.parentElement || null;
    while (node && node !== document.body) {
      const style = getComputedStyle(node);
      const canScrollY = /(auto|scroll|overlay)/.test(style.overflowY) && node.scrollHeight > node.clientHeight;
      if (canScrollY) return node;
      node = node.parentElement;
    }
    return window;
  }
  function getScrollTop(scroller) {
    return scroller === window
      ? window.pageYOffset || document.documentElement.scrollTop || 0
      : scroller.scrollTop;
  }
  function setScrollTop(scroller, value) {
    if (scroller === window) window.scrollTo(0, value);
    else scroller.scrollTop = value;
  }
  function easeInOutCubic(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }
  function animateScrollTo(scroller, to, { duration = 800 } = {}) {
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) { setScrollTop(scroller, to); return Promise.resolve(); }
    const start = getScrollTop(scroller);
    const change = to - start;
    if (Math.abs(change) < 1) return Promise.resolve();
    const px = Math.abs(change);
    duration = Math.min(1100, Math.max(550, (px / 1200) * 900));
    return new Promise(resolve => {
      const startTime = performance.now();
      function step(now) {
        const t = Math.min(1, (now - startTime) / duration);
        const eased = easeInOutCubic(t);
        setScrollTop(scroller, start + change * eased);
        if (t < 1) requestAnimationFrame(step); else resolve();
      }
      requestAnimationFrame(step);
    });
  }
  function scrollTitleIntoView(sectionEl) {
    const title = sectionEl?.querySelector('.form-content__title');
    if (!title) return;
    const scroller = getScrollContainer(title);
    const offset = measureStickyStack();
    const titleRect = title.getBoundingClientRect();
    const baseTop = scroller === window
      ? titleRect.top + getScrollTop(window)
      : titleRect.top + scroller.scrollTop - (scroller.getBoundingClientRect ? scroller.getBoundingClientRect().top : 0);
    const desiredY = baseTop - offset;
    animateScrollTo(scroller, desiredY).then(() => {
      const containerTop = scroller === window ? 0 : scroller.getBoundingClientRect().top;
      const delta = title.getBoundingClientRect().top - (offset + containerTop);
      if (Math.abs(delta) > 1) setScrollTop(scroller, getScrollTop(scroller) + delta);
    });
  }
  function scrollToFormTopMobile() {
    if (!window.matchMedia('(max-width: 600px)').matches) return false;
    const formTopElement = document.querySelector('.leasing-form-outer-wrapper');
    if (!formTopElement) return false;
    const scroller = getScrollContainer(formTopElement);
    const offset = measureStickyStack();
    const rect = formTopElement.getBoundingClientRect();
    const scrollTop = getScrollTop(scroller);
    const baseTop = scroller === window
      ? rect.top + scrollTop
      : rect.top + scrollTop - scroller.getBoundingClientRect().top;
    const targetY = baseTop - offset;
    animateScrollTo(scroller, targetY);
    return true;
  }
  function scrollAfterReveal(sectionEl) {
    requestAnimationFrame(() => {
      if (scrollToFormTopMobile()) return;
      scrollTitleIntoView(sectionEl);
    });
  }

  // =========================
  // Step nav
  // =========================
  function setActiveStep(n) {
    stepsNav?.querySelectorAll('.step').forEach(li => {
      li.classList.toggle('step--active', li.getAttribute('data-step') === String(n));
    });
  }
  function showStep(n) {
    [step1, step2, step3].forEach((s, i) => {
      if (!s) return;
      if (i === n - 1) s.classList.remove('is-hidden');
      else s.classList.add('is-hidden');
    });
    setActiveStep(n);
  }

  // =========================
  // Tooltip error CSS (no layout shift)
  // =========================
  (function injectTooltipCSS() {
    const css = `
      .field-host{ position:relative; }
      .field-error{
        position:absolute; left:0; top:100%; transform:translateY(6px);
        z-index:10; color:#b42318; background:#fff; border:1px solid #f3b4b1;
        border-radius:4px; padding:2px 6px; font-size:.85rem; line-height:1.2;
        white-space:nowrap; pointer-events:none; box-shadow:0 1px 2px rgba(0,0,0,.06);
      }
      .field-error::after{
        content:""; position:absolute; left:10px; top:-6px;
        border-left:6px solid transparent; border-right:6px solid transparent;
        border-bottom:6px solid #f3b4b1;
      }
      .field-error::before{
        content:""; position:absolute; left:10px; top:-5px;
        border-left:6px solid transparent; border-right:6px solid transparent;
        border-bottom:6px solid #fff;
      }
      .no-spinner::-webkit-outer-spin-button,.no-spinner::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}
      .no-spinner{-moz-appearance:textfield}

      /* ===== FINAL DESKTOP ALIGNMENT FIX ===== */
      @media (min-width: 769px) {
        /*
         * Use the :has() selector to target ONLY the form groups containing
         * the specific side-by-side inputs on desktop.
         * This pushes their error tooltips to align with the input column.
        */
        .form-group:has(#Shareholders-0-HowLong) > .field-error,
        .form-group:has(#Shareholders-0-HomeValue) > .field-error,
        .form-group:has(#Shareholders-0-MortgageBalance) > .field-error {
          left: 18%; /* Adjust this % if your label/input split is different */
        }
      }
      /* ===== END FINAL FIX ===== */
    `;
    const s = document.createElement('style');
    s.type = 'text/css';
    s.appendChild(document.createTextNode(css));
    document.head.appendChild(s);
  })();

  // =========================
  // Error helpers
  // =========================
  function wrapAllFieldsForTooltips() {
    const form = formEl;
    if (!form) return;
    const selector = [
      'input:not([type="hidden"]):not([type="button"]):not([type="submit"])',
      'textarea',
      'select'
    ].join(',');
    form.querySelectorAll(selector).forEach((el) => {
      if (el.closest('.field-host')) return;
      const prefer = el.closest('.form-group');
      if (prefer) { prefer.classList.add('field-host'); return; }
      const rq = el.closest('.radio-question') || el.closest('.radio-options');
      if (rq) { rq.classList.add('field-host'); return; }
      const wrap = document.createElement('div');
      wrap.className = 'field-host';
      el.replaceWith(wrap);
      wrap.appendChild(el);
    });
    form.querySelectorAll('.radio-question, .radio-options').forEach(g => g.classList.add('field-host'));
  }
  function clearErrors(scope) {
    (scope || document).querySelectorAll('.field-error').forEach(n => n.remove());
    (scope || document).querySelectorAll('[aria-invalid="true"]').forEach(n => n.setAttribute('aria-invalid', 'false'));
  }
  function showError(inputEl, msg) {
    if (!inputEl) return;
    inputEl.setAttribute('aria-invalid', 'true');
    const host =
      inputEl.closest('.field-host') ||
      inputEl.closest('.form-group') ||
      inputEl.closest('.radio-question') ||
      inputEl.closest('.radio-options') ||
      inputEl.parentElement;
    if (!host) return;
    const existing = host.querySelector(':scope > .field-error');
    if (existing) { existing.textContent = msg; return; }
    const hint = document.createElement('div');
    hint.className = 'field-error';
    hint.setAttribute('role', 'status');
    hint.setAttribute('aria-live', 'polite');
    hint.textContent = msg;
    host.appendChild(hint);
  }
  function clearErrorFor(inputEl) {
    if (!inputEl) return;

    inputEl.setAttribute('aria-invalid', 'false');

    const host =
      inputEl.closest('.field-host') ||
      inputEl.closest('.nw-field') ||
      inputEl.closest('.form-group') ||
      inputEl.closest('.radio-question') ||
      inputEl.closest('.radio-options') ||
      inputEl.parentElement;

    if (!host) return;

    const existing = host.querySelector(':scope > .field-error');
    if (existing) existing.remove();
  }
  function focusAndScrollTo(el) {
    try { el.focus({ preventScroll: true }); } catch { }
    const scroller = getScrollContainer(el);
    const offset = measureStickyStack();
    const rect = el.getBoundingClientRect();
    const baseTop = (scroller === window)
      ? rect.top + getScrollTop(window)
      : rect.top + scroller.scrollTop - scroller.getBoundingClientRect().top;
    animateScrollTo(scroller, baseTop - Math.max(0, offset) - 12);
  }

  // =========================
  // Currency inputs (Home Value + Mortgage Balance)
  // =========================
  function _fmtCurrencyTyping(raw) {
    var v = (raw || '').replace(/[^0-9.]/g, '');
    var dot = v.indexOf('.');
    var int = v, dec = '';
    if (dot !== -1) {
      int = v.slice(0, dot);
      dec = v.slice(dot + 1).replace(/\./g, '').slice(0, 2);
    }
    int = int.replace(/^0+(?=\d)/, '');
    var intWithCommas = int ? int.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0';
    return '$' + intWithCommas + (dot !== -1 ? (dec.length ? '.' + dec : '.') : '');
  }
  function _fmtCurrencyBlur(raw) {
    var v = (raw || '').replace(/[^0-9.]/g, '');
    if (!v) return '';
    var dot = v.indexOf('.');
    var int = v, dec = '';
    if (dot !== -1) {
      int = v.slice(0, dot);
      dec = v.slice(dot + 1).replace(/\./g, '').slice(0, 2);
    }
    int = int.replace(/^0+(?=\d)/, '');
    var intWithCommas = (int || '0').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var dec2 = (dec + '00').slice(0, 2);
    return '$' + intWithCommas + '.' + dec2;
  }
  function wireCurrencyInputById(id, { max = null } = {}) {
    var el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('inputmode', 'decimal');
    el.setAttribute('step', '0.01');
    el.classList.add('no-spinner');
    el.addEventListener('input', function () {
      var wasFocused = (document.activeElement === el);
      el.value = _fmtCurrencyTyping(el.value);
      if (wasFocused) {
        try { el.selectionStart = el.selectionEnd = el.value.length; } catch (e) { }
      }
      computeProgress();
    });
    el.addEventListener('blur', function () {
      el.value = _fmtCurrencyBlur(el.value);
      if (max !== null) {
        var n = parseFloat((el.value || '').replace(/[^0-9.]/g, ''));
        if (!isNaN(n) && n > max) el.value = _fmtCurrencyBlur(String(max));
      }
    });
  }

  // =========================
  // Digits-only helper
  // =========================
  function wireDigitsOnlyById(id, { maxDigits = null, max = null } = {}) {
    const el = document.getElementById(id);
    if (!el) return;
    el.setAttribute('type', 'text');
    el.setAttribute('inputmode', 'numeric');
    el.setAttribute('pattern', '\\d*');
    el.classList.add('no-spinner');
    el.addEventListener('input', () => {
      let v = (el.value || '').replace(/\D/g, '');
      if (maxDigits) v = v.slice(0, maxDigits);
      el.value = v;
      computeProgress();
    });
    if (max !== null) {
      el.addEventListener('blur', () => {
        if (el.value === '') return;
        let n = parseInt(el.value, 10);
        if (isNaN(n)) { el.value = ''; computeProgress(); return; }
        if (n > max) n = max;
        el.value = String(n);
        computeProgress();
      });
    }
  }

  // =========================
  // Phone formatting (10 digits)
  // =========================
  const onlyDigits = (v) => (v || '').replace(/\D/g, '');
  function fmtPhone(digits) {
    const d = onlyDigits(digits).slice(0, 10);
    if (d.length <= 3) return d;
    if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  }
  function wirePhoneInput(el) {
    if (!el) return;
    el.setAttribute('maxlength', '14');
    el.addEventListener('input', () => {
      const d = onlyDigits(el.value);
      el.value = fmtPhone(d);
      if (d.length === 10) el.setCustomValidity('');
      computeProgress();
    });
    el.addEventListener('blur', () => {
      const d = onlyDigits(el.value);
      if (d.length > 0 && d.length !== 10) {
        el.setCustomValidity('Please enter a 10-digit phone number.');
        el.reportValidity?.();
      } else {
        el.setCustomValidity('');
      }
    });
  }
  function atLeastOnePhoneOk(ids) {
    return ids.some(id => onlyDigits(document.getElementById(id)?.value || '').length === 10);
  }

  // =========================
  // SIN formatting (9 digits, XXX-XXX-XXX) -- never autofilled/cached.
  // =========================
  function fmtSin(digits) {
    const d = onlyDigits(digits).slice(0, 9);
    if (d.length <= 3) return d;
    if (d.length <= 6) return `${d.slice(0, 3)}-${d.slice(3)}`;
    return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
  }
  function wireSinInput(el) {
    if (!el) return;
    el.setAttribute('maxlength', '11');
    el.addEventListener('input', () => {
      const d = onlyDigits(el.value);
      el.value = fmtSin(d);
      if (d.length === 9) el.setCustomValidity('');
      computeProgress();
    });
    el.addEventListener('blur', () => {
      const d = onlyDigits(el.value);
      if (d.length > 0 && d.length !== 9) {
        el.setCustomValidity('Please enter a 9-digit SIN.');
        el.reportValidity?.();
      } else {
        el.setCustomValidity('');
      }
    });
  }
  function sinValidSoft() {
    const el = document.getElementById('Shareholders-0-SIN');
    if (!el) return true;
    const d = onlyDigits(el.value);
    if (d.length > 0 && d.length !== 9) {
      showError(el, 'This must be a 9-digit SIN.');
      focusAndScrollTo(el);
      return false;
    }
    return true;
  }

  // =========================
  // Required checkbox helpers
  // =========================
  function requireConsent() {
    const box = document.getElementById('LeasingForm-consent') || formEl?.querySelector('input[name="consent"]');
    if (!box) return true;
    if (!box.checked) {
      showError(box, 'Please check this box to proceed.');
      focusAndScrollTo(box);
      return false;
    }
    return true;
  }

  // =========================
  // Dynamic Field Visibility
  // =========================
  const shareholderHomeStatusRadios = formEl?.querySelectorAll('input[name="shareholders[0][home_status]"]');
  const homeValInput = document.getElementById('Shareholders-0-HomeValue');
  const mortBalInput = document.getElementById('Shareholders-0-MortgageBalance');
  const homeValGroup = homeValInput ? homeValInput.closest('.form-group') : null;
  const mortBalGroup = mortBalInput ? mortBalInput.closest('.form-group') : null;

  function toggleShareholderHomeFields() {
    if (!shareholderHomeStatusRadios || !homeValGroup || !mortBalGroup) { computeProgress(); return; }
    const isLessee = !!formEl.querySelector('input[name="shareholders[0][home_status]"][value="Lessee"]:checked');
    homeValGroup.classList.toggle('is-hidden', isLessee);
    mortBalGroup.classList.toggle('is-hidden', isLessee);
    if (isLessee) {
      const hv = homeValGroup.querySelector('input');
      const mb = mortBalGroup.querySelector('input');
      if (hv) hv.value = '';
      if (mb) mb.value = '';
    }
    wireCurrencyInputById('Shareholders-0-HomeValue');
    wireCurrencyInputById('Shareholders-0-MortgageBalance');
    computeProgress();
  }

  const companyBankruptcyRadios = formEl?.querySelectorAll('input[name="commercial_bankruptcy"]');
  const companyDoRInput = document.getElementById('Company-DateOfRelease');
  function toggleCompanyDoR() {
    if (!companyDoRInput || !companyBankruptcyRadios) return;
    const yes = !!formEl.querySelector('input[name="commercial_bankruptcy"][value="Yes"]:checked');
    const container =
      companyDoRInput.closest('.form-group') ||
      companyDoRInput.closest('.field-host') ||
      companyDoRInput.parentElement;
    if (container) {
      container.classList.toggle('is-hidden', !yes);
      if (!yes) companyDoRInput.value = '';
    }
    computeProgress();
  }

  const shBankruptcyRadios = formEl?.querySelectorAll('input[name="shareholders[0][commercial_bankruptcy]"]');
  const shDoRInput = document.getElementById('Shareholders-0-DateOfRelease');
  function toggleShareholderDoR() {
    if (!shDoRInput || !shBankruptcyRadios) { computeProgress(); return; }
    const yes = !!formEl.querySelector('input[name="shareholders[0][commercial_bankruptcy]"][value="Yes"]:checked');
    const container =
      shDoRInput.closest('.form-group') ||
      shDoRInput.closest('.field-host') ||
      shDoRInput.parentElement;
    if (container) {
      container.classList.toggle('is-hidden', !yes);
      if (!yes) shDoRInput.value = '';
    }
    computeProgress();
  }

  // =========================
  // Validation (per step)
  // =========================
  formEl?.setAttribute('novalidate', 'novalidate');

  function valNonEmpty(inputEl, msg) {
    if (!inputEl) return true;
    if (String(inputEl.value).trim() === '') {
      showError(inputEl, msg);
      focusAndScrollTo(inputEl);
      return false;
    }
    return true;
  }
  function valRadioChecked(sectionEl, name, msg) {
    const chosen = sectionEl?.querySelector(`input[name="${name}"]:checked`);
    if (!chosen) {
      const first = sectionEl?.querySelector(`input[name="${name}"]`);
      showError(first, msg);
      focusAndScrollTo(first);
      return false;
    }
    return true;
  }
  function phonesValidSoft() {
    const ids = ['LeasingForm-business-phone', 'LeasingForm-mobile-number', 'Shareholders-0-Phone', 'Shareholders-0-Mobile'];
    for (const id of ids) {
      const el = document.getElementById(id);
      if (!el) continue;
      const d = onlyDigits(el.value);
      if (d.length > 0 && d.length !== 10) {
        showError(el, 'Please enter a 10-digit phone number or leave blank.');
        focusAndScrollTo(el);
        return false;
      }
    }
    return true;
  }
  function ensureEmailValidOrFocus() {
    const email = document.getElementById('LeasingForm-email');
    if (!email) return true;
    if (!email.value || !email.checkValidity()) {
      showError(email, 'Please enter a valid email.');
      focusAndScrollTo(email);
      return false;
    }
    return true;
  }

  function validateStep(sectionEl) {
    if (!VALIDATION_ENABLED) return true;
    clearErrors(sectionEl);
    const step = Number(sectionEl?.getAttribute('data-step') || 0);

    // STEP 1 rules
    if (step === 1) {
      const legal = sectionEl.querySelector('input[name="legal_name_of_business"]');
      const operating = sectionEl.querySelector('input[name="operating_name"]');
      const activity = sectionEl.querySelector('input[name="activity_area"]');
      const addr = sectionEl.querySelector('input[name="address"]');
      const phone = sectionEl.querySelector('#LeasingForm-business-phone');
      const mobile = sectionEl.querySelector('#LeasingForm-mobile-number');
      const email = sectionEl.querySelector('input[name="contact[email]"]');
      const years = sectionEl.querySelector('input[name="years_in_business"]');
      const leaseAmount = sectionEl.querySelector('input[name="lease_amount_required"]');

      if (!valNonEmpty(legal, 'Please enter the legal business name.')) return false;
      if (!valNonEmpty(operating, 'Please enter the operating name.')) return false;
      if (!valNonEmpty(activity, 'Please enter the activity area.')) return false;
      if (!valNonEmpty(addr, 'Please enter the company address.')) return false;

      const businessDigits = onlyDigits(phone?.value || '');
      const mobileDigits = onlyDigits(mobile?.value || '');
      if (!businessDigits && !mobileDigits) {
        showError(phone || mobile, 'Please provide at least one phone number.');
        focusAndScrollTo(phone || mobile);
        return false;
      }

      if (!valNonEmpty(email, 'Please enter your email.')) return false;
      if (!email.checkValidity()) { showError(email, 'Please enter a valid email.'); focusAndScrollTo(email); return false; }

      if (!valNonEmpty(years, 'Please enter years in business.')) return false;

      if (!valNonEmpty(leaseAmount, 'Please enter the estimated lease amount required.')) return false;
      {
        const leaseAmountValue = parseFloat((leaseAmount.value || '').replace(/[^0-9.]/g, ''));
        if (isNaN(leaseAmountValue) || leaseAmountValue <= 0) {
          showError(leaseAmount, 'Please enter a valid lease amount.');
          focusAndScrollTo(leaseAmount);
          return false;
        }
        if (leaseAmountValue > MAX_LEASE_AMOUNT) {
          showError(leaseAmount, `Estimated lease amount cannot exceed $${MAX_LEASE_AMOUNT.toLocaleString()}.`);
          focusAndScrollTo(leaseAmount);
          return false;
        }
      }

      if (!valRadioChecked(sectionEl, 'commercial_bankruptcy', 'Please answer about commercial bankruptcy.')) return false;

      if (companyDoRInput) {
        const companyYes = !!formEl.querySelector('input[name="commercial_bankruptcy"][value="Yes"]:checked');
        if (companyYes && !valNonEmpty(companyDoRInput, 'Please enter the Date of Release.')) return false;
      }

      if (!valRadioChecked(sectionEl, 'legal_actions', 'Please answer about legal actions.')) return false;

      return true;
    }

    // STEP 2 rules
    if (step === 2) {
      const wrap = sectionEl.querySelector('.shareholder');
      if (!wrap) return true;

      const fields = Array.from(wrap.querySelectorAll('input'));
      const anyFilled = fields.some(i => String(i.value).trim().length > 0);
      if (!anyFilled) return true;

      const name = wrap.querySelector('input[name="shareholders[0][contact_name]"]');
      const addr = wrap.querySelector('input[name="shareholders[0][address]"]');
      const dob = wrap.querySelector('#Shareholders-0-DOB');
      const tel = wrap.querySelector('#Shareholders-0-Phone');
      const mob = wrap.querySelector('#Shareholders-0-Mobile');
      const how = wrap.querySelector('#Shareholders-0-HowLong');
      const hv = wrap.querySelector('#Shareholders-0-HomeValue');
      const mb = wrap.querySelector('#Shareholders-0-MortgageBalance');
      const yearInc = wrap.querySelector('#Shareholders-0-YearIncorporated');

      if (!valNonEmpty(name, 'Shareholder contact name is required.')) return false;
      if (!valNonEmpty(addr, 'Shareholder address is required.')) return false;

      if (!valNonEmpty(dob, 'Shareholder date of birth is required.')) return false;
      if (!isValidDate(dob.value)) {
        showError(dob, 'Invalid date. Format must be YYYY-MM-DD.');
        focusAndScrollTo(dob);
        return false;
      }

      const telDigits = onlyDigits(tel?.value || '');
      const mobDigits = onlyDigits(mob?.value || '');
      if (!telDigits && !mobDigits) {
        showError(tel || mob, 'Provide at least one phone for shareholder.');
        focusAndScrollTo(tel || mob);
        return false;
      }
      if (!phonesValidSoft()) return false;

      if (!valRadioChecked(wrap, 'shareholders[0][home_status]', 'Select Home Owner or Lessee.')) return false;

      if (!valNonEmpty(how, 'Please enter How Long at current residence.')) return false;

      const homeStatus = wrap.querySelector('input[name="shareholders[0][home_status]"]:checked')?.value || '';
      if (homeStatus === 'Home Owner') {
        if (!valNonEmpty(hv, 'Please enter the Home Value.')) return false;
        if (!valNonEmpty(mb, 'Please enter the Mortgage Balance.')) return false;
      }

      if (!valRadioChecked(wrap, 'shareholders[0][commercial_bankruptcy]', 'Please pick one option.')) return false;

      const shYes = !!wrap.querySelector('input[name="shareholders[0][commercial_bankruptcy]"][value="Yes"]:checked');

      // 2. If Yes, validate the Date Input
      if (shYes && shDoRInput) {
        // A. Check if empty
        if (!valNonEmpty(shDoRInput, 'Please enter the Date of Release.')) {
          return false;
        }

        // B. Check if it is a real calendar date (YYYY-MM-DD)
        if (!isValidDate(shDoRInput.value)) {
          showError(shDoRInput, 'Invalid date. Format must be YYYY-MM-DD.');
          focusAndScrollTo(shDoRInput);
          return false;
        }
      }

      if (!valNonEmpty(yearInc, 'Please enter the Year Incorporated.')) return false;

      let y = parseInt(yearInc.value, 10);
      if (isNaN(y) || y < 1900 || y > CUR_YEAR) {
        showError(yearInc, `Year must be between 1900 and ${CUR_YEAR}.`);
        focusAndScrollTo(yearInc);
        return false;
      }
      return true;
    }

    return true;
  }

  // =========================
  // Progress (entire form)
  // =========================
  const byName = (n) => formEl?.querySelector(`[name="${n}"]`);
  const val = (n) => (byName(n)?.value || '').toString().trim();
  const radio = (n) => !!formEl?.querySelector(`[name="${n}"]:checked`);
  const isEmailOk = () => {
    const el = document.getElementById('LeasingForm-email');
    return el && el.value.trim() !== '' && el.checkValidity();
  };

  function computeProgress() {
    let required = 0, satisfied = 0;

    const step1Checks = [
      () => { required++; if (isEmailOk()) satisfied++; },
      () => { required++; if (val('legal_name_of_business')) satisfied++; },
      () => { required++; if (val('operating_name')) satisfied++; },
      () => { required++; if (val('activity_area')) satisfied++; },
      () => { required++; if (val('address')) satisfied++; },
      () => { required++; if (val('years_in_business')) satisfied++; },
      () => { required++; if (val('lease_amount_required')) satisfied++; },
      () => { required++; if (atLeastOnePhoneOk(['LeasingForm-business-phone', 'LeasingForm-mobile-number'])) satisfied++; },
      () => { required++; if (radio('commercial_bankruptcy')) satisfied++; },
      () => { required++; if (radio('legal_actions')) satisfied++; },
    ];
    step1Checks.forEach(fn => fn());

    if (companyDoRInput) {
      const yes = !!formEl.querySelector('input[name="commercial_bankruptcy"][value="Yes"]:checked');
      if (yes) { required++; if (val(companyDoRInput.name || 'Company-DateOfRelease')) satisfied++; }
    }

    const shStarted = Array.from(step2?.querySelectorAll('.shareholder input') || [])
      .some(i => (i.value || '').trim().length);
    if (shStarted) {
      const getRadioVal = (name) => (formEl?.querySelector(`[name="${name}"]:checked`)?.value || '').trim();

      const step2Checks = [
        () => { required++; if (val('shareholders[0][contact_name]')) satisfied++; },
        () => { required++; if (val('shareholders[0][address]')) satisfied++; },
        () => { required++; if (isValidDate(val('shareholders[0][date_of_birth]'))) satisfied++; },
        () => { required++; if (atLeastOnePhoneOk(['Shareholders-0-Phone', 'Shareholders-0-Mobile'])) satisfied++; },
        () => { required++; if (radio('shareholders[0][home_status]')) satisfied++; },
        () => { required++; if (val('shareholders[0][how_long]')) satisfied++; },
        () => { required++; if (radio('shareholders[0][commercial_bankruptcy]')) satisfied++; },
        () => {
          required++; const v = val('shareholders[0][year_incorporated]'); const y = parseInt(v, 10);
          if (!!v && !isNaN(y) && y >= 1900 && y <= CUR_YEAR) satisfied++;
        },
      ];
      step2Checks.forEach(fn => fn());

      if (getRadioVal('shareholders[0][home_status]') === 'Home Owner') {
        required += 2;
        if (val('shareholders[0][home_value]')) satisfied++;
        if (val('shareholders[0][mortgage_balance]')) satisfied++;
      }

      if (getRadioVal('shareholders[0][commercial_bankruptcy]') === 'Yes') {
        required += 1;
        if (val('shareholders[0][date_of_release]')) satisfied++;
      }
    }

    setProgress(required ? (satisfied / required) * 100 : 0);
  }

  // =========================
  // Navigation
  // =========================
  goToStep2?.addEventListener('click', (e) => {
    e.preventDefault();
    if (!validateStep(step1)) return;
    showStep(2);
    scrollAfterReveal(step2);
    computeProgress();
  });
  goToStep3?.addEventListener('click', (e) => {
    e.preventDefault();
    if (!validateStep(step2)) return;
    showStep(3);
    scrollAfterReveal(step3);
    computeProgress();
  });
  backToStep2?.addEventListener('click', (e) => {
    e.preventDefault();
    showStep(2);
    scrollAfterReveal(step2);
    computeProgress();
  });
  backToStep1?.addEventListener('click', (e) => {
    e.preventDefault();
    showStep(1);
    scrollAfterReveal(step1);
    computeProgress();
  });

  // Give the multi-step wizard proper browser back/forward support.
  // Before this, there was no history entry per step, so tapping the
  // browser's back button left the whole form/page instead of going to
  // the previous step -- easy to lose typed progress by accident.
  // Purely additive: attaches extra click listeners to the same
  // Continue/Previous buttons already wired above (fires after their own
  // validation/show logic has already run each time, so it only needs to
  // read whichever step ended up visible rather than duplicating any
  // validation). Browser back/forward itself doesn't re-run
  // Continue-button validation -- final submit already re-validates
  // every step regardless of how the applicant got there, so this
  // doesn't weaken anything, it just makes back/forward behave like a
  // normal multi-step form instead of an all-or-nothing page.
  (function wireStepHistory() {
    const steps = [step1, step2, step3].filter(Boolean);
    if (steps.length < 2) return;

    function currentVisibleStep() {
      const idx = steps.findIndex(s => !s.classList.contains('is-hidden'));
      return idx === -1 ? 1 : idx + 1;
    }

    // A per-page-load token stamped into every history entry this script
    // execution creates. History entries survive a refresh (the browser
    // keeps the whole back/forward stack, each still carrying whatever
    // state object was pushed before) -- without this, pressing
    // browser-back enough times after a refresh could still land on an
    // old pre-refresh entry claiming "Step 2," even though this fresh
    // page load reset every field to empty and never actually
    // re-validated its way there. Comparing loadId lets popstate tell
    // "genuinely visited earlier in this load" apart from "leftover from
    // before the last refresh."
    const LOAD_ID = Date.now() + '-' + Math.random().toString(36).slice(2);

    // Hardcoded to 1, not read from the current DOM state -- this IIFE
    // runs at top-level script execution, which can happen *before*
    // init()'s showStep(1) has a chance to force the correct baseline
    // (e.g. on a browser-restored stale DOM after refresh). A fresh
    // script execution should always be treated as starting at Step 1
    // regardless of what the DOM momentarily shows.
    let lastStep = 1;
    // "leasing-step-N", not "step-N" -- the sections themselves already
    // use id="step-N", and a hash matching a real element id can trigger
    // the browser's native anchor-scroll behavior on a fresh load/refresh,
    // independent of anything this code does.
    history.replaceState({ leasingStep: lastStep, loadId: LOAD_ID }, '', location.pathname + location.search + '#leasing-step-' + lastStep);

    window.addEventListener('popstate', (e) => {
      const state = e.state;
      const isThisLoad = !!state && state.loadId === LOAD_ID;
      const n = isThisLoad ? (state.leasingStep || 1) : 1;
      if (!isThisLoad) {
        // Stale entry from before a refresh -- correct it in place
        // (re-stamped with this load's id) so further back/forward from
        // here stays consistent instead of repeatedly resurfacing the
        // same stale step.
        history.replaceState({ leasingStep: 1, loadId: LOAD_ID }, '', '#leasing-step-1');
      }
      if (n === lastStep) return;
      lastStep = n;
      showStep(n);
      computeProgress();
      scrollAfterReveal(steps[n - 1]);
    });

    // Continue-style buttons push a new entry (forward progress);
    // Previous-style buttons replace the current one (so pressing
    // Previous then browser-back doesn't confusingly move forward again
    // through a leftover duplicate entry).
    function recordStep(replace) {
      const n = currentVisibleStep();
      if (n === lastStep) return; // click was blocked by validation -- nothing actually changed
      lastStep = n;
      history[replace ? 'replaceState' : 'pushState']({ leasingStep: n, loadId: LOAD_ID }, '', '#leasing-step-' + n);
    }

    [goToStep2, goToStep3].forEach(btn => btn?.addEventListener('click', () => recordStep(false)));
    [backToStep1, backToStep2].forEach(btn => btn?.addEventListener('click', () => recordStep(true)));
  })();

  // Warn before an accidental refresh/close/navigate-away loses typed
  // progress. Does NOT fire for in-form step navigation (Continue/
  // Previous use pushState/replaceState above, not a real page unload --
  // browsers don't fire beforeunload for same-document history changes)
  // or for a genuine submission (suppressed via isSubmitting, set in the
  // submit button's click handler below right before the real submit is
  // allowed to proceed).
  let isSubmitting = false;
  function hasAnyFormData() {
    if (!formEl) return false;
    const fields = formEl.querySelectorAll('input, textarea, select');
    for (const el of fields) {
      if (el.type === 'hidden' || el.type === 'submit' || el.type === 'button') continue;
      if (el.type === 'checkbox' || el.type === 'radio') {
        if (el.checked) return true;
        continue;
      }
      if ((el.value || '').toString().trim() !== '') return true;
    }
    return false;
  }
  window.addEventListener('beforeunload', (e) => {
    if (isSubmitting || !hasAnyFormData()) return;
    e.preventDefault();
    e.returnValue = ''; // Chrome requires this to be set to show the prompt
  });

  // =========================
  // Build contact[body] for Shopify
  // =========================
  function buildContactBody() {
    const get = (n) => (formEl?.querySelector(`[name="${n}"]`)?.value || '').toString().trim();
    const getRadio = (name) => (formEl?.querySelector(`[name="${name}"]:checked`)?.value || '').toString().trim();
    const lines = [];

    lines.push('Pre-Approval Application');
    lines.push('========================');
    lines.push('');
    lines.push('Company Info');
    lines.push('------------');
    lines.push(`Email: ${get('contact[email]')}`);
    lines.push(`Legal Name: ${get('legal_name_of_business')}`);
    lines.push(`Operating Name: ${get('operating_name')}`);
    lines.push(`Activity Area: ${get('activity_area')}`);
    lines.push(`Address: ${get('address')}`);
    lines.push(`Business Phone: ${get('business_phone')}`);
    lines.push(`Mobile Number: ${get('mobile_number')}`);
    lines.push(`Years in Business: ${get('years_in_business')}`);
    lines.push(`Estimated Lease Amount Required: ${get('lease_amount_required')}`);
    lines.push(`Commercial Bankruptcy: ${getRadio('commercial_bankruptcy')}`);
    const cdor = document.getElementById('Company-DateOfRelease')?.value || '';
    if (cdor) lines.push(`Date of Release: ${cdor}`);
    lines.push(`Legal Actions: ${getRadio('legal_actions')}`);
    lines.push('');
    lines.push('Shareholders / Partners');
    lines.push('-----------------------');
    lines.push(`Contact Name: ${get('shareholders[0][contact_name]')}`);
    lines.push(`Address: ${get('shareholders[0][address]')}`);
    lines.push(`Date of Birth: ${get('shareholders[0][date_of_birth]')}`);
    lines.push(`Telephone: ${get('shareholders[0][telephone]')}`);
    lines.push(`Mobile: ${get('shareholders[0][mobile]')}`);
    lines.push(`Home Status: ${getRadio('shareholders[0][home_status]')}`);
    lines.push(`How Long: ${get('shareholders[0][how_long]')}`);
    lines.push(`Home Value: ${get('shareholders[0][home_value]')}`);
    lines.push(`Mortgage Balance: ${get('shareholders[0][mortgage_balance]')}`);
    lines.push(`Commercial Bankruptcy: ${getRadio('shareholders[0][commercial_bankruptcy]')}`);
    lines.push(`Date of Release: ${get('shareholders[0][date_of_release]')}`);
    lines.push(`Year Incorporated: ${get('shareholders[0][year_incorporated]')}`);
    lines.push('');

    const equipmentProducts = get('equipment_products');
    const equipmentNotes = get('equipment_additional_info');
    if (equipmentProducts || equipmentNotes) {
      lines.push('Equipment Required');
      lines.push('------------------');
      if (equipmentProducts) lines.push(`Linked Products: ${equipmentProducts}`);
      if (equipmentNotes) lines.push(`Additional Information: ${equipmentNotes}`);
      lines.push('');
    }

    return lines.join('\n');
  }

  // Build the field list for HubSpot's Forms API, mapping this page's
  // nested field names to flat property names. SIN is intentionally never
  // included. See the full form's equivalent function for the fuller
  // explanation -- this form only ever has one shareholder row, but the
  // same row-based lookup is reused for consistency.
  function buildHubSpotFields() {
    const fields = [];
    const push = (name, value) => {
      const v = (value ?? '').toString().trim();
      if (v) fields.push({ name, value: v });
    };
    // HubSpot Number-type properties reject the on-page display format
    // ("$122,222.00") -- confirmed via a live rejected submission, not
    // guessed. Strip everything but digits/decimal point before sending.
    const pushNumber = (name, value) => push(name, (value ?? '').toString().replace(/[^0-9.]/g, ''));
    const get = (name) => (formEl?.querySelector(`[name="${name}"]`)?.value || '').toString().trim();
    const getRadio = (name) => (formEl?.querySelector(`[name="${name}"]:checked`)?.value || '').toString().trim();

    push('email', get('contact[email]'));
    push('legal_name_of_business', get('legal_name_of_business'));
    push('operating_name', get('operating_name'));
    push('activity_area', get('activity_area'));
    push('address', get('address'));
    push('business_phone', get('business_phone'));
    // HubSpot's own built-in Mobile Phone Number property -- confirmed via
    // HubSpot's rejection message on a live submission ("should be
    // mobilephone"), not assumed.
    push('mobilephone', get('mobile_number'));
    push('years_in_business', get('years_in_business'));
    pushNumber('lease_amount_required', get('lease_amount_required'));
    push('equipment_products', get('equipment_products'));
    push('equipment_additional_info', get('equipment_additional_info'));
    push('commercial_bankruptcy', getRadio('commercial_bankruptcy'));
    push('company_date_of_release', document.getElementById('Company-DateOfRelease')?.value || '');
    // Confirmed via HubSpot's rejection message on a live submission -- the
    // actual property created in the portal is legal_actions_against_company.
    push('legal_actions_against_company', getRadio('legal_actions'));

    const shareholderRows = Array.from(formEl?.querySelectorAll('.shareholder') || []);
    shareholderRows.slice(0, HUBSPOT_SHAREHOLDER_SLOTS).forEach((row, i) => {
      const n = i + 1;
      const rv = (suffix) => (row.querySelector(`[name$="[${suffix}]"]`)?.value || '').toString().trim();
      const rRadio = (suffix) => (row.querySelector(`[name$="[${suffix}]"]:checked`)?.value || '').toString().trim();
      push(`shareholder_${n}_contact_name`, rv('contact_name'));
      push(`shareholder_${n}_address`, rv('address'));
      // shareholder SIN intentionally excluded from HubSpot.
      push(`shareholder_${n}_date_of_birth`, rv('date_of_birth'));
      push(`shareholder_${n}_telephone`, rv('telephone'));
      push(`shareholder_${n}_mobile`, rv('mobile'));
      push(`shareholder_${n}_home_status`, rRadio('home_status'));
      push(`shareholder_${n}_how_long`, rv('how_long'));
      pushNumber(`shareholder_${n}_home_value`, rv('home_value'));
      pushNumber(`shareholder_${n}_mortgage_balance`, rv('mortgage_balance'));
      push(`shareholder_${n}_commercial_bankruptcy`, rRadio('commercial_bankruptcy'));
      push(`shareholder_${n}_date_of_release`, rv('date_of_release'));
      push(`shareholder_${n}_year_incorporated`, rv('year_incorporated'));
    });

    return fields;
  }

  // Fire-and-forget POST to the same-origin form relay, run alongside
  // (never instead of) the native Shopify submission. Failures are
  // swallowed (logged, not thrown) so a relay/HubSpot outage can never
  // block the real submission.
  //
  // The token itself is fetched up front and refreshed periodically, not
  // at submit time: a valid submission navigates away immediately, which
  // tears down this script's JS context before a token fetched right then
  // could reliably resolve -- `keepalive` only protects an already-sent
  // request, not a `.then()` waiting to send a second one after it. A
  // pre-fetched token keeps submit time down to that one keepalive request.
  const FORM_TOKEN_REFRESH_MS = 5 * 60 * 1000; // server TTL is 10 min; refresh with margin
  let cachedFormToken = null;

  function fetchFormToken() {
    return fetch(FORM_TOKEN_URL)
      .then(r => r.json())
      .then(data => (data && data.token) || null)
      .catch(() => null);
  }

  function refreshFormToken() {
    fetchFormToken().then(token => { cachedFormToken = token; });
  }

  if (formEl) {
    refreshFormToken();
    setInterval(refreshFormToken, FORM_TOKEN_REFRESH_MS);
  }

  function submitToHubSpot() {
    try {
      const payload = {
        fields: buildHubSpotFields(),
        pageUri: window.location.href,
        pageName: document.title,
      };
      fetch(RELAY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...payload, formToken: cachedFormToken }),
        keepalive: true,
      }).catch(err => console.warn('HubSpot relay failed (Shopify submission is unaffected):', err));
    } catch (err) {
      console.warn('HubSpot relay failed (Shopify submission is unaffected):', err);
    }
  }

  // =========================
  // Submit Logic - FINAL, BASED ON WORKING EXAMPLE
  // =========================
  submitBtn?.addEventListener('click', (e) => {
    clearErrors();
    let ok = true;

    if (ok && !validateStep(step1)) { showStep(1); scrollAfterReveal(step1); ok = false; }
    if (ok && !validateStep(step2)) { showStep(2); scrollAfterReveal(step2); ok = false; }
    if (ok && !validateStep(step3)) { showStep(3); scrollAfterReveal(step3); ok = false; }
    if (ok && !requireConsent()) ok = false;
    if (ok && !phonesValidSoft()) ok = false;
    if (ok && !sinValidSoft()) ok = false;

    if (!ok) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation?.();
      return false;
    }

    const bodyEl = document.getElementById('LeasingForm-body');
    if (bodyEl) bodyEl.value = buildContactBody();
    // Validation passed and the native Shopify submit is about to
    // proceed -- fire the parallel HubSpot sync alongside it, and
    // suppress the beforeunload warning so a genuine submit doesn't also
    // trigger a "leave site?" prompt.
    isSubmitting = true;
    submitToHubSpot();

    return true;
  });

  formEl?.addEventListener('submit', (e) => {
    if (!validateStep(step1) || !validateStep(step2) || !validateStep(step3) || !requireConsent()) {
      e.preventDefault();
      return;
    }
  });

  // =========================
  // Events → progress & toggles
  // =========================
  formEl?.addEventListener('input', (e) => { clearErrors(e.target.closest('section')); computeProgress(); }, { passive: true });
  formEl?.addEventListener('change', (e) => { clearErrors(e.target.closest('section')); computeProgress(); }, { passive: true });

  shareholderHomeStatusRadios?.forEach(radio => radio.addEventListener('change', toggleShareholderHomeFields));
  companyBankruptcyRadios?.forEach(r => r.addEventListener('change', toggleCompanyDoR));
  shBankruptcyRadios?.forEach(r => r.addEventListener('change', toggleShareholderDoR));

  window.addEventListener('resize', () => {
    syncScrollPaddingTop();
    [step1, step2, step3].forEach(s => {
      if (s && !s.classList.contains('is-hidden')) setTitleScrollMargin(s);
    });
  }, { passive: true });

  // =========================
  // Init
  // =========================
  function init() {
    setProgress(0);
    // showStep(), not just setActiveStep() -- forces every step's
    // is-hidden state back to "only Step 1 visible" on every script
    // execution, regardless of whatever the DOM's current class list
    // happens to be. setActiveStep() alone only updates the sidebar's
    // active-step highlight, not the actual step panels' visibility, so
    // it silently trusted a fresh page load to already have the right
    // classes -- true for a real server-rendered load, but not
    // guaranteed if the browser restores a stale, already-mutated DOM on
    // refresh (some browsers do this for pages with typed form data),
    // which could leave a later step visible with an empty Step 1 behind
    // it, unvalidated.
    showStep(1);
    syncScrollPaddingTop();
    setTitleScrollMargin(step1);
    wrapAllFieldsForTooltips();
    document.querySelectorAll('.datepicker-input').forEach(wireUpDatepicker);
    document.querySelectorAll('.datepicker-input').forEach(wireUpDateMask);

    // Wire phones
    ['LeasingForm-business-phone', 'LeasingForm-mobile-number', 'Shareholders-0-Phone', 'Shareholders-0-Mobile']
      .forEach(id => wirePhoneInput(document.getElementById(id)));

    // Wire SIN
    wireSinInput(document.getElementById('Shareholders-0-SIN'));

    // Wire money fields
    wireCurrencyInputById('Shareholders-0-HomeValue');
    wireCurrencyInputById('Shareholders-0-MortgageBalance');
    wireCurrencyInputById('LeasingForm-lease-amount', { max: MAX_LEASE_AMOUNT });

    wireDigitsOnlyById('Shareholders-0-HowLong', { maxDigits: 3, max: 100 });
    wireDigitsOnlyById('LeasingForm-years-in-business', { maxDigits: 3, max: 100 });

    const yearInc = document.getElementById('Shareholders-0-YearIncorporated');
    if (yearInc) {
      yearInc.setAttribute('type', 'text');
      yearInc.setAttribute('inputmode', 'numeric');
      yearInc.setAttribute('pattern', '\\d*');
      yearInc.classList.add('no-spinner');
      yearInc.addEventListener('input', () => {
        yearInc.value = (yearInc.value || '').replace(/\D/g, '').slice(0, 4);
        computeProgress();
      });
      yearInc.addEventListener('blur', () => {
        if (!yearInc.value) return;
        let n = parseInt(yearInc.value, 10);
        if (isNaN(n)) { yearInc.value = ''; computeProgress(); return; }
        if (n < 1900) n = 1900;
        if (n > CUR_YEAR) n = CUR_YEAR;
        yearInc.value = String(n);
        computeProgress();
      });
    }

    toggleShareholderHomeFields();
    toggleCompanyDoR();
    toggleShareholderDoR();
    wireProductSearch();

    computeProgress();
  }

  // Equipment Required: search and link products from the site (Shopify's
  // native predictive search JSON endpoint -- decoupled from Boost, which
  // powers the main site search but isn't needed for this lightweight
  // lookup), each with a thumbnail and quantity, plus a free-text notes
  // field. Both optional -- no validation. Selected products serialize
  // into a hidden input (joined by "; ", each as "Qty x Title (url)") for
  // the Shopify email body and HubSpot payload; the notes field is a real
  // named textarea, no JS wiring needed for its value. Price is
  // intentionally not shown or included -- explicitly requested.
  function wireProductSearch() {
    const input = document.getElementById('LeasingForm-product-search');
    const resultsEl = document.getElementById('LeasingForm-product-results');
    const listEl = document.getElementById('LeasingForm-product-list');
    const hiddenEl = document.getElementById('LeasingForm-equipment-products');
    if (!input || !resultsEl || !listEl || !hiddenEl) return;

    // Business rule, not inferred: confirmed max distinct products.
    const MAX_EQUIPMENT_PRODUCTS = 30;
    const selected = [];
    let controller = null;
    let debounceTimer = null;

    function updateHiddenValue() {
      hiddenEl.value = selected
        .map((p) => `${p.quantity} x ${p.title}${p.url ? ` (${p.url})` : ''}`)
        .join('; ');
    }

    function renderSelected() {
      listEl.innerHTML = '';
      selected.forEach((product, index) => {
        const li = document.createElement('li');

        if (product.image) {
          const img = document.createElement('img');
          img.src = product.image;
          img.alt = '';
          img.loading = 'lazy';
          img.className = 'equipment-list__image';
          li.appendChild(img);
        }

        // Products found via search always have a real url; a referral
        // product that couldn't be confidently matched (see
        // prefillFromReferral() below) may not -- an <a> with no href
        // isn't a real link (no pointer cursor, not clickable/focusable)
        // but still picks up the same CSS as a normal entry.
        const link = document.createElement('a');
        if (product.url) {
          link.href = product.url;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
        }
        link.textContent = product.title;
        li.appendChild(link);

        const qtyInput = document.createElement('input');
        qtyInput.type = 'number';
        qtyInput.min = '1';
        qtyInput.value = String(product.quantity);
        qtyInput.className = 'equipment-list__qty';
        qtyInput.setAttribute('aria-label', `Quantity for ${product.title}`);
        // Update the model + hidden value directly on input rather than
        // calling renderSelected() again -- rebuilding the list on every
        // keystroke would recreate this input and steal focus mid-typing.
        qtyInput.addEventListener('input', () => {
          const n = parseInt(qtyInput.value, 10);
          if (!isNaN(n) && n >= 1) product.quantity = n;
          updateHiddenValue();
        });
        qtyInput.addEventListener('blur', () => {
          const n = parseInt(qtyInput.value, 10);
          product.quantity = (!isNaN(n) && n >= 1) ? n : 1;
          qtyInput.value = String(product.quantity);
          updateHiddenValue();
        });
        li.appendChild(qtyInput);

        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'equipment-remove';
        removeBtn.setAttribute('aria-label', `Remove ${product.title}`);
        removeBtn.textContent = '×';
        removeBtn.addEventListener('click', () => {
          selected.splice(index, 1);
          renderSelected();
        });
        li.appendChild(removeBtn);

        listEl.appendChild(li);
      });
      updateHiddenValue();
    }

    function hideResults() {
      resultsEl.classList.add('is-hidden');
      resultsEl.innerHTML = '';
    }

    // Shared by selectProduct() (user clicks a search result) and
    // prefillFromReferral() (silent, on page load) -- both need the same
    // dedupe-by-url/increment-quantity logic, but only one of them should
    // also touch the search input/dropdown UI.
    // Returns true if the product was actually added/incremented, false
    // if it was a new product blocked by MAX_EQUIPMENT_PRODUCTS (an
    // existing product's quantity can always be incremented -- only a
    // genuinely new row counts against the cap).
    function addToSelected(product) {
      const existing = product.url && selected.find((p) => p.url === product.url);
      if (existing) {
        existing.quantity += 1;
        renderSelected();
        return true;
      }
      if (selected.length >= MAX_EQUIPMENT_PRODUCTS) return false;
      selected.push({ ...product, quantity: 1 });
      renderSelected();
      return true;
    }

    function selectProduct(product) {
      if (!addToSelected(product)) {
        resultsEl.innerHTML = `<div class="product-search-result--empty">Maximum ${MAX_EQUIPMENT_PRODUCTS} products reached -- remove one to add another.</div>`;
        resultsEl.classList.remove('is-hidden');
        return;
      }
      input.value = '';
      hideResults();
      input.focus();
    }

    // Pre-fill from a PDP financing link's ?sku=...&product=... context
    // (see urlCtx up top) -- the visitor already told us which product
    // they're interested in by clicking through, so don't make them
    // search for it again. Looks the SKU up via the same predictive
    // search endpoint used elsewhere in this widget to get the product's
    // real url/image (the query string only carries a sku and a display
    // title, neither of which is a url), falling back to the raw title
    // text with no url/image if no confident match comes back.
    function prefillFromReferral() {
      const query = urlCtx.sku || urlCtx.product;
      if (!query) return;

      const baseUrl = (window.routes && window.routes.predictive_search_url) || '/search/suggest.json';
      const url = `${baseUrl}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=1&resources[options][fields]=title,variants.sku,vendor,product_type`;

      fetch(url, { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((data) => {
          const match = (data?.resources?.results?.products || [])[0];
          if (match) {
            addToSelected({
              title: match.title,
              url: match.url && match.url.startsWith('/') ? window.location.origin + match.url : match.url,
              image: match.image || '',
            });
          } else if (urlCtx.product) {
            addToSelected({ title: urlCtx.product, url: '', image: '' });
          }
        })
        .catch(() => {
          if (urlCtx.product) addToSelected({ title: urlCtx.product, url: '', image: '' });
        });
    }

    function renderResults(products) {
      resultsEl.innerHTML = '';
      if (!products.length) {
        const empty = document.createElement('div');
        empty.className = 'product-search-result--empty';
        empty.textContent = 'No products found.';
        resultsEl.appendChild(empty);
      } else {
        products.forEach((product) => {
          const row = document.createElement('div');
          row.className = 'product-search-result';

          if (product.image) {
            const img = document.createElement('img');
            img.src = product.image;
            img.alt = '';
            img.loading = 'lazy';
            img.className = 'product-search-result__image';
            row.appendChild(img);
          }

          const title = document.createElement('span');
          title.className = 'product-search-result__title';
          title.textContent = product.title;
          row.appendChild(title);

          row.addEventListener('click', () => selectProduct(product));
          resultsEl.appendChild(row);
        });
      }
      resultsEl.classList.remove('is-hidden');
    }

    function search(query) {
      if (controller) controller.abort();
      controller = new AbortController();

      const baseUrl = (window.routes && window.routes.predictive_search_url) || '/search/suggest.json';
      // Explicit `fields` so SKU is always a matched field, not just
      // relying on Shopify's undocumented default -- confirmed via a live
      // test query against a real product SKU that this exact fields list
      // still matches by title too.
      const url = `${baseUrl}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,variants.sku,vendor,product_type`;

      resultsEl.innerHTML = '<div class="product-search-result--loading">Searching...</div>';
      resultsEl.classList.remove('is-hidden');

      fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((data) => {
          const products = (data?.resources?.results?.products || []).map((p) => ({
            title: p.title,
            url: p.url && p.url.startsWith('/') ? window.location.origin + p.url : p.url,
            image: p.image || '',
          }));
          renderResults(products);
        })
        .catch((err) => {
          if (err.name === 'AbortError') return;
          hideResults();
        });
    }

    input.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      const query = input.value.trim();
      if (query.length < 2) {
        hideResults();
        return;
      }
      debounceTimer = setTimeout(() => search(query), 300);
    });

    // Re-show results when refocusing a box that already has text -- the
    // 'input' event above only fires on a value change, so clicking back
    // into the field after it lost focus (which closes the dropdown, see
    // the document click handler below) did nothing without this.
    input.addEventListener('focus', () => {
      const query = input.value.trim();
      if (query.length >= 2) search(query);
    });

    input.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') { hideResults(); return; }
      if (e.key === 'Enter') {
        // Prevent this text input from submitting the (single, multi-step)
        // form -- select the top visible match instead.
        e.preventDefault();
        const first = resultsEl.querySelector('.product-search-result');
        if (first) first.click();
      }
    });

    document.addEventListener('click', (e) => {
      if (!e.target.closest('.product-search-row')) hideResults();
    });

    prefillFromReferral();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();